// Analytics senders. Each function targets one vendor; track() is the default
// fan-out used across the app. Also exposed as window.trackEvent for inline ERB.

// GTM custom event — the marketer maps these to GA4 / Meta / etc. in the GTM UI.
export const trackGtm = (event, params = {}) => {
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({ event, ...params })
}

// Hotjar custom event (name only — Hotjar events carry no payload). Prod only.
export const trackHotjar = (event) => {
  if (typeof window.hj === "function") {
    window.hj("event", event)
  }
}

// GA4 / gtag command passthrough — pushes the command's arguments onto dataLayer,
// which gtag.js forwards to GA4. Used for "js", "config" and "event" commands. Most
// events reach GA4 through GTM (trackGtm) instead; this is the direct gtag path.
export function trackGa4() {
  window.dataLayer = window.dataLayer || []
  // biome-ignore lint/complexity/noArguments: gtag requires the arguments object, not an array
  window.dataLayer.push(arguments)
}

// YouLead form-conversion beacon. window.Monitor is provided by m.js (prod/beta only),
// so a call elsewhere is a no-op.
export const trackYouLeadForm = (formId, params) => {
  if (typeof window.Monitor === "undefined") {
    return
  }

  if (params) {
    window.Monitor.TrackForm(formId, null, null, params)
  } else {
    window.Monitor.TrackForm(formId)
  }
}

// All YouLead push events go onto the ylData buffer that m.js drains.
const pushYlData = (entry) => {
  window.ylData = window.ylData || []
  window.ylData.push(entry)
}

// YouLead in-page navigation (hash links).
export const trackYouLeadPage = (value) => {
  pushYlData({ page: { extendedValue: value } })
}

// YouLead product view — products is an array of YouLead product ids.
export const trackYouLeadProduct = (products) => {
  pushYlData({ product: { products } })
}

// YouLead add-to-cart — products is an array of { productId, quantity, price }.
export const trackYouLeadCart = (products) => {
  pushYlData({ "cart.add": { products } })
}

// YouLead custom event — params (a string) is optional.
export const trackYouLeadEvent = (eventName, params) => {
  pushYlData({
    event: params === undefined ? { eventName } : { eventName, params },
  })
}

// Default fan-out: send an event to the GTM dataLayer and Hotjar.
export const track = (event, params = {}) => {
  trackGtm(event, params)
  trackHotjar(event)
}

// Exposed for inline scripts in ERB views, which can't import ES modules.
window.trackEvent = track
window.trackGa4 = trackGa4
window.trackYouLeadForm = trackYouLeadForm
